<template>
  <referral-details :id="selectedReferral" v-if="selectedReferral" @close="selectedReferral = null" direction="sent" />
  <referral-index direction="sent" @selected="selectedReferral = $event" v-else />
</template>

<script>
import { mapState } from 'vuex'
import ReferralDetails from './ReferralDetails.vue'
import ReferralIndex from './ReferralIndex.vue'
export default {
  components: { ReferralIndex, ReferralDetails },
  data () {
    return {
      selectedReferral: null
    }
  },
  computed: {
    ...mapState(['selectedOffice'])
  },
  watch: {
    selectedOffice: {
      handler () {
        this.selectedReferral = null
      },
      deep: true
    }
  }
}
</script>
